import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import templateView from './templateView';

const schema: JSONSchema7 = {
    title: 'HTML Block',
    type: 'object',
    required: ['editorHtml'],
    properties: {
        editorHtml: {
            type: 'string',
            title: 'HTML Text',
            default: 'some text...',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        dependencies: {
            ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        },
    },
};

const groups = [
    {
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['editorHtml'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    editorHtml: {
        'ui:widget': 'ResourcePicker',
    },
};

const HtmlBLockWidget: commonTypes.IWidget = {
    // without default
    schema,
    uiSchema,
    templateView,
    contentPlaceHolders: [],
    id: 'HtmlBlock',
    group: 'component',
    initialData: () => ({
        name: 'Text',
        classnames: '',
        editorHtml: 'Placeholder',
    }),
};

export default HtmlBLockWidget;
